import "../comp-styles/ModalAddVinculacion.scss";
import Iconos from "../IconosDeSitio";

const USER_TYPES = [
  "",
  "Médico",
  "",
  "Paciente",
  "Asistente",
  "Familiar"
];

function VincAddCardModal({ usersToAdd, sendSolicitudes, closeModal }) {
  let listaContactos = usersToAdd;
  return (
    <>
      {listaContactos && listaContactos.map((lista) => (
        <div key={lista.id}>
          <div className="GeneralContVincul">
            <div className="ContainerVincula">
              <div className="CardVincula">
                <div style={{ display: "flex", gap: "2%", width: "100%" }} onClick={() => {
                  sendSolicitudes(lista.id);
                  closeModal(true);
                }}>
                  <div className="BgrImgv">
                    <img
                      src={
                        lista.imagen !== null
                          ? "https://" + lista.imagen
                          : Iconos[0]
                      }
                      alt=""
                    />
                  </div>
                  <div>
                    <b style={{ width: "80%", overflow: "hidden", textOverflow: "ellipsis" }} >{lista.nombre}</b>
                    <div className="Dia">
                      <span>
                        <b>
                          {USER_TYPES[lista.tipo]}
                        </b>
                        &nbsp;&nbsp; {lista.correo}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default VincAddCardModal;
